import { render, staticRenderFns } from "./IncomeAndEarningPotential.vue?vue&type=template&id=1c1158a6"
import script from "./IncomeAndEarningPotential.vue?vue&type=script&lang=ts"
export * from "./IncomeAndEarningPotential.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports